module.exports = __webpack_public_path__ + "media/images/order/tomferry-logo-white-md-36e23762ed4654b17a047e5a1e127ae1.png";